/* Approved About page: public catalogue count and motion, with reduced-motion support. */
(() => {
  'use strict';
  const root = document.getElementById('ab');
  if (!root) return;
  const doc = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduce.matches;
  const rows = [...document.querySelectorAll('[data-public-collab]')].map(el => {
    try { return JSON.parse(el.textContent); } catch { return null; }
  }).filter(Boolean);
  const count = rows.length;
  const countEls = [...root.querySelectorAll('[data-about-count]')];
  const label = root.querySelector('[data-about-label]');
  let countFrame;
  function finishCount() {
    cancelAnimationFrame(countFrame);
    countEls.forEach(el => { el.textContent = String(count); });
  }
  if (count) {
    finishCount();
    if (count === 1 && label) label.textContent = label.dataset.one;
    root.querySelector('[data-about-live]').hidden = false;
    root.querySelector('[data-about-fallback]').hidden = true;
    root.querySelector('[data-about-sticker]').hidden = false;
  }
  if (count && !paused) {
    let start;
    function tick(time) {
      if (paused) return finishCount();
      if (start === undefined) start = time;
      const progress = Math.min(1, (time - start) / 1100);
      const value = Math.round(count * (1 - Math.pow(1 - progress, 3)));
      countEls.forEach(el => { el.textContent = String(value); });
      if (progress < 1) countFrame = requestAnimationFrame(tick);
    }
    countFrame = requestAnimationFrame(tick);
  }
  const sections = [...root.querySelectorAll('.ab-sec,.ab-sustain')];
  let initialTarget;
  try { initialTarget = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch { initialTarget = null; }
  const initialSection = initialTarget && initialTarget.closest('.ab-sec,.ab-sustain');
  if (initialSection) initialSection.classList.add('in');
  sections.forEach(section => {
    section.querySelectorAll('.ab-copy>ul>li,.ab-copy>ol>li,.ab-cats>li,.ab-cause-stories>li').forEach((item, i) => {
      item.classList.add('ab-stagger');
      item.style.setProperty('--ab-delay', Math.min(i * 95, 380) + 'ms');
    });
  });
  if ('IntersectionObserver' in window && !paused) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -5% 0px' });
    sections.forEach(section => { if (!section.classList.contains('in')) observer.observe(section); });
    root.classList.add('ab-js');
  } else {
    sections.forEach(section => section.classList.add('in'));
  }
  function applyMotion() {
    doc.classList.toggle('ab-motion-paused', paused);
    root.classList.toggle('ab-motion', !paused);
    if (paused) {
      finishCount();
      sections.forEach(section => section.classList.add('in'));
    }
  }
  const onMotionChange = event => { paused = event.matches; applyMotion(); };
  if (reduce.addEventListener) reduce.addEventListener('change', onMotionChange);
  else if (reduce.addListener) reduce.addListener(onMotionChange);
  applyMotion();
  if (initialTarget && document.fonts) {
    document.fonts.ready.then(() => {
      const saved = doc.style.scrollBehavior;
      doc.style.scrollBehavior = 'auto';
      initialTarget.scrollIntoView({ block: 'start' });
      requestAnimationFrame(() => { doc.style.scrollBehavior = saved; });
    });
  }
})();
